import { render } from "./CameraUpload.vue?vue&type=template&id=22e71033"
const script = {}
script.render = render

export default script